export const VISIBLE_ITEMS = 3;

export const DELAY = 1000;

export const ASSET_KEYS = ['departments', 'locations', 'groups', 'users', 'email_addresses'];

export const LOCATION_ATTRIBUTES = {
  ids: 'location_ids',
  items: 'locations',
};

export const DEPARTMENT_ATTRIBUTES = {
  ids: 'department_ids',
  items: 'departments',
};

export const GROUP_ATTRIBUTES = {
  ids: 'group_ids',
  items: 'groups',
};

export const USER_ATTRIBUTES = {
  ids: 'user_ids',
  items: 'users',
};
